import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../api/api";
import { toast } from "react-toastify";
import { Carousel } from "react-bootstrap";
import Slider from "../components/Slider";

export default function VerifyOtp() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const email = state?.email;

  const [resendTimer, setResendTimer] = useState(0);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!email) navigate("/");
  }, [email, navigate]);

  // Countdown timer
  useEffect(() => {
    if (resendTimer === 0) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [resendTimer]);

  const handleResendOtp = async () => {
    try {
      setResending(true);
      await api.post("/otp/resend", { email });
      toast.success("New OTP sent to your email");
      setResendTimer(60); // ⏱️ 60 sec cooldown
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to resend OTP");
    } finally {
      setResending(false);
    }
  };

  return (
      <main className="login-screen">
        <div className="container">
          <div className="row align-items-center">
            
            <div className="col-md-6 order-2 order-md-1">
                  <Slider className="login-slider">
                <Carousel.Item>
                  <img src="images/slide1.png" className="img-fluid" />
                  <Carousel.Caption>
                    <h2>It's just OTP verification</h2>
                    <p>You are one step away from recovering your password.</p>
                  </Carousel.Caption>
                </Carousel.Item>
    
                <Carousel.Item>
                  <img src="images/slide2.png" className="img-fluid" />
                  <Carousel.Caption>
                    <h2>Slide 2</h2>
                    <p>Slide 2 subtext</p>
                  </Carousel.Caption>
                </Carousel.Item>
              </Slider>
            </div>
            <div className="col-md-6 order-1 order-md-2 right-sec">
              <div className="logo-sec">
                <img src="images/logo.svg" className="logo" />
              </div>         
    
              <h1 className="title1">Enter OTP</h1>
              <div className="subtitle">Sent OTP on <span>{email}</span></div>
               <Formik
          initialValues={{ otp: "" }}
          validationSchema={Yup.object({
            otp: Yup.string()
              .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
              .required("OTP is required"),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await api.post("/otp/verify", {
                email,
                otp: values.otp,
              });
              toast.success("Email verified successfully");
              navigate("/login");
            } catch (err) {
              toast.error(err.response?.data?.error || "Invalid OTP");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form noValidate  className="login-forms mt-4">
              <div className="mb-2">
                <div className="input-wrapper mb-2">
                  <img src="/icons/otp.svg" alt="otp" className="input-icon left" />
                  <Field name="otp" className="form-control form_input" placeholder="Enter 6-digit OTP"/>
                              
                </div> 
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="text-danger small mt-1"
                />
                {/* <Field
                  name="otp"
                  className="form-control"
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                />
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="text-danger small mt-1"
                /> */}
              </div>

              <button
                type="submit"
                className="btn-style1 mt-4"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Verifying..." : "Verify OTP"}
              </button>
            </Form>
          )}
        </Formik>

        <div className="footer-text">
          <a
          href="#"
          className={`btn btn-link p-0 ${
            resendTimer > 0 || resending ? "disabled" : ""
          }`}
          onClick={(e) => {
            e.preventDefault();
            if (resendTimer > 0 || resending) return;
            handleResendOtp();
          }}
        >
          {resending
            ? "Sending..."
            : resendTimer > 0
            ? `Resend OTP in ${resendTimer}s`
            : "Resend OTP"}
        </a>
          {/* <button
            className="btn btn-link p-0"
            disabled={resendTimer > 0 || resending}
            onClick={handleResendOtp}
          >
            {resending
              ? "Sending..."
              : resendTimer > 0
              ? `Resend OTP in ${resendTimer}s`
              : "Resend OTP"}
          </button> */}
        </div>
            </div>
        </div>
      </div>
   { /*<div className="container mt-5">
      <div className="card col-md-4 mx-auto p-4 shadow-sm">
        <h4 className="mb-3 text-center">Email Verification</h4>

        <p className="text-muted text-center mb-3">
          OTP sent to <strong>{email}</strong>
        </p>

        <Formik
          initialValues={{ otp: "" }}
          validationSchema={Yup.object({
            otp: Yup.string()
              .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
              .required("OTP is required"),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await api.post("/otp/verify", {
                email,
                otp: values.otp,
              });
              toast.success("Email verified successfully");
              navigate("/login");
            } catch (err) {
              toast.error(err.response?.data?.error || "Invalid OTP");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form noValidate>
              <div className="mb-2">
                <Field
                  name="otp"
                  className="form-control"
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                />
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="text-danger small mt-1"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 mt-3"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Verifying..." : "Verify OTP"}
              </button>
            </Form>
          )}
        </Formik>

        <div className="text-center mt-3">
          <button
            className="btn btn-link p-0"
            disabled={resendTimer > 0 || resending}
            onClick={handleResendOtp}
          >
            {resending
              ? "Sending..."
              : resendTimer > 0
              ? `Resend OTP in ${resendTimer}s`
              : "Resend OTP"}
          </button>
        </div>
      </div>
    </div>*/}
    </main>
  );
}
